/**
 * Audit Logs Page
 *
 * Administration page for viewing audit logs and activity history.
 * @see US-19a.28
 */

import { ScrollText } from 'lucide-react';
import { AuditLogList } from '../components/AuditLogList';

export default function AuditLogsPage() {
  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="bg-white border-b border-neutral-200 px-6 py-4 flex-shrink-0">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary-100 rounded-lg">
            <ScrollText className="w-5 h-5 text-primary-600" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-dark-500">Journal d'activite</h1>
            <p className="text-sm text-neutral-500 mt-0.5">
              Historique des actions et evenements du systeme
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto p-6 bg-neutral-50">
        <AuditLogList />
      </div>
    </div>
  );
}
